import React from "react";
import { View, StyleSheet } from "react-native";
import BaseMarketingController from "./BaseMarketingController";
import NtMarketingPageContainer from "../components/general/NtMarketingPageContainer";
import NtE911Section from "../components/e911/NtE911Section";
import NtE911FeatureSection from "../components/e911/NtE911FeatureSection";
import NtInquirySection from "../components/general/NtInquirySection";

class E911ServiceController extends BaseMarketingController {
  state = {};
  render() {
    return (
      <NtMarketingPageContainer style={styles.container}>
        <NtE911Section />
        <NtE911FeatureSection />
        <NtInquirySection
          title={
            "If you are interested in getting more information about E911 Enterprises such as, how to get a quote, sign-up for our services, suggestions or questions, please submit our contact form below. We will respond promptly."
          }
          subject={"911 Enterprise Inquiry Request"}
        />
      </NtMarketingPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default E911ServiceController;
